import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  Text,
  Select,
  VStack,
  HStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiHome, FiUploadCloud, FiFileText, FiShield, FiInbox } from 'react-icons/fi';
import HeaderMenus from '../HeaderMenus';

// PA demo: fully self-contained — no backend calls.
const PA_CLIENTS = [
  { id: 'ffhc', name: 'Frankford Family Health Center', emr_type: 'OCHIN Epic' },       // Philadelphia — 6 sites, ~46k patients
  { id: 'svch', name: 'Susquehanna Valley Community Health', emr_type: 'eClinicalWorks' }, // Harrisburg
  { id: 'trnh', name: 'Three Rivers Neighborhood Health', emr_type: 'NextGen' }           // Pittsburgh
];

const FqPaLayout = () => {
  const [clients] = useState(PA_CLIENTS);
  const [selectedClient, setSelectedClient] = useState('all');
  const location = useLocation();

  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const sidebarBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const NavItem = ({ icon, children, to }) => {
    const isActive = location.pathname.includes(to);
    return (
      <Link to={to} style={{ width: '100%' }}>
        <Flex
          align="center"
          p="4"
          mx="4"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          bg={isActive ? 'blue.500' : 'transparent'}
          color={isActive ? 'white' : 'inherit'}
          _hover={{
            bg: isActive ? 'blue.600' : 'gray.100',
            color: isActive ? 'white' : 'gray.900',
          }}
        >
          {icon && (
            <Icon
              mr="4"
              fontSize="16"
              as={icon}
            />
          )}
          {children}
        </Flex>
      </Link>
    );
  };

  return (
    <Flex direction="column" h="100vh">
      <HeaderMenus />
      <Flex flex="1" bg={bgColor} overflow="hidden">
        {/* Sidebar */}
        <Box
          w="64"
          bg={sidebarBg}
          borderRight="1px"
          borderRightColor={borderColor}
          py="5"
          overflowY="auto"
        >
        <VStack spacing="4" align="stretch">
          <Box px="8" mb="4">
            <Text fontSize="xl" fontWeight="bold" color="blue.600">
              HMS Billing
            </Text>
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" letterSpacing="wide" mt={1}>
              FQHC Revenue Layer
            </Text>
          </Box>
          
          <Box px="4" mb="6">
            <Select 
              size="sm" 
              value={selectedClient} 
              onChange={(e) => setSelectedClient(e.target.value)}
              bg={useColorModeValue('gray.50', 'gray.700')}
            >
              <option value="all">All Clients (Aggregate)</option>
              {clients.map(c => (
                <option key={c.id} value={c.id}>
                  {c.name} ({c.emr_type})
                </option>
              ))}
            </Select>
          </Box>

          <NavItem icon={FiHome} to="/fq-pa/dashboard">Dashboard</NavItem>
          <NavItem icon={FiUploadCloud} to="/fq-pa/intake">EDI Intake</NavItem>
          <NavItem icon={FiShield} to="/fq-pa/pre-submission">Pre-Submission</NavItem>
          <NavItem icon={FiInbox} to="/fq-pa/835-review">835 Review</NavItem>
          <NavItem icon={FiFileText} to="/fq-pa/claims">Claims & Rules</NavItem>

          <Box px="8" mt="6" mb="2">
            <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wide">
              Deep Knowledge Demos
            </Text>
          </Box>
          <NavItem icon={FiFileText} to="/fq-pa/demo/code-intelligence">Code Intelligence</NavItem>
          <NavItem icon={FiFileText} to="/fq-pa/demo/carve-out-analyzer">Carve-Out Analyzer</NavItem>
          <NavItem icon={FiFileText} to="/fq-pa/demo/wrap-compliance">Wrap Compliance</NavItem>
          <NavItem icon={FiFileText} to="/fq-pa/demo/denial-intelligence">Denial Intelligence</NavItem>
        </VStack>
      </Box>

      {/* Main Content */}
        <Box flex="1" overflowY="auto" p="8">
          {/* We pass the selectedClient down via context to the Outlet */}
          <Outlet context={{ selectedClient }} />
        </Box>
      </Flex>
    </Flex>
  );
};

export default FqPaLayout;
